import * as types from './types'
import storage from '@/Plugins/storage'

export default () => ({
  pager: storage.session.getItem(types.STORE_PAGER)
    ? JSON.parse(storage.session.getItem(types.STORE_PAGER))
    : {
        pageSize: 10,
        orderBy: 'asc',
        sortBy: null,
        search: null,
        total: 0,
        page: 1,
        pages: 1,
      },
  defaultFeedPost: {
    id: null,
    organization_id: null,
    challenge_id: null,
    sender_id: null,
    text: null,
    s3: null,
    images: null,
    videos: null,
    video_thumbnails: null,
    delete_images: null,
    add_images: null,
  },
  defaultComment: {
    id: null,
    feed_id: null,
    organization_id: null,
    text: '',
    sender_id: null,
  },
  feedPost: null,
  feed: [],
  comment: null,
})
